// extracted by mini-css-extract-plugin
export default {"bannerImageWrapper":"BannerImage_bannerImageWrapper__zABFz","bannerImage":"BannerImage_bannerImage__8QqO4"};